/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';

import GetAWPackageInformation from '../services/GetAWPackageInformation';
import CalculateAWPackageDeviceCount from '../services/CalculateAWPackageDeviceCount';
import GetAllContractExtensionTypes from '../services/GetAllContractExtensionTypes';
import LegacyAWPackageInformationView from '../views/LegacyAWPackageInformationView';

export default async function loadLegacyAWPackageInformationView({
  awPackageId,
  editable,
  toggleContractExtensionCheck = false
}) {
  const [awPackage, deviceCount, contractExtensionTypes] = await Promise.all([
    GetAWPackageInformation(awPackageId),
    CalculateAWPackageDeviceCount(awPackageId),
    GetAllContractExtensionTypes()
  ]);

  let toggleContractExtension = true;
  if (toggleContractExtensionCheck) {
    toggleContractExtension = awPackage.awPackageContractExtensions.length > 0 ? true : false;
  }

  awPackage.deviceCount = deviceCount;

  return new LegacyAWPackageInformationView({
    model: new Backbone.Model({
      awPackage,
      contractExtensionTypes,
      editable,
      toggleContractExtension
    })
  });
}
